import { environment } from './environment';

/**
 * Avisa quando um build de produção está consumindo um backend que não é de
 * produção. Executa uma única vez, no bootstrap, antes de qualquer requisição.
 *
 * Não interrompe a aplicação de propósito: hoje o deploy de produção contra
 * homologação é uma pendência conhecida e bloquear o boot deixaria o portal
 * fora do ar. O objetivo é apenas tornar a situação visível.
 */
export function warnOnApiTargetMismatch(): void {
  if (!environment.production || environment.apiTarget === 'production') return;

  console.warn(
    `[followee-web] Build de PRODUÇÃO consumindo a API de ${environment.apiTarget}: ` +
    `${environment.apiBaseUrl}. Configure src/environments/environment.prod.ts ` +
    `antes de publicar a versão final.`
  );
}
